import { useEffect, useState } from 'react';
import { NavLink, useLocation } from 'react-router-dom';

const items = [
  { to: '/', label: '首页', icon: 'ri-home-5-line', end: true },
  { to: '/category/tech', label: '分类', icon: 'ri-apps-2-line', end: false },
  { to: '/community', label: '社区', icon: 'ri-chat-smile-2-line', end: false },
  { to: '/search', label: '搜索', icon: 'ri-search-line', end: false },
  { to: '/favorites', label: '收藏', icon: 'ri-heart-line', end: false },
];

export default function MobileNav() {
  const [visible, setVisible] = useState(true);
  const location = useLocation();

  useEffect(() => {
    let lastY = window.scrollY;
    const onScroll = () => {
      const currentY = window.scrollY;
      const goingDown = currentY > lastY && currentY > 120;
      setVisible(!goingDown);
      lastY = currentY;
    };
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  useEffect(() => {
    setVisible(true);
  }, [location.pathname]);

  return (
    <nav
      className={`lg:hidden fixed bottom-0 left-0 right-0 z-50 border-t border-background-200 bg-background-50/95 backdrop-blur-md transition-transform duration-300 ${
        visible ? 'translate-y-0' : 'translate-y-full'
      }`}
      style={{ paddingBottom: 'env(safe-area-inset-bottom)' }}
    >
      <div className="grid grid-cols-5">
        {items.map((item) => (
          <NavLink
            key={item.to}
            to={item.to}
            end={item.end}
            className={({ isActive }) =>
              `flex flex-col items-center gap-1 py-2.5 text-[11px] transition-colors ${
                isActive ? 'text-primary-600' : 'text-foreground-500'
              }`
            }
          >
            <span className="w-6 h-6 flex items-center justify-center">
              <i className={`${item.icon} text-xl`}></i>
            </span>
            <span>{item.label}</span>
          </NavLink>
        ))}
      </div>
    </nav>
  );
}